import { styled } from "@mui/material";

import type { CommonProps } from "@mui/material/OverridableComponent";
import type { FC } from "react";

const BaseLogo: FC<CommonProps> = (props) => (
  <svg
    width={180}
    height={185}
    viewBox="0 0 180 185"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7503_28037)">
      <path
        d="M155.101 180.02L143.123 156.44H75.307C71.5381 156.44 67.9235 157.938 65.2585 160.603C62.5935 163.268 61.0963 166.882 61.0963 170.651C61.0963 174.42 62.5935 178.035 65.2585 180.7C67.9235 183.365 71.5381 184.862 75.307 184.862H165.708C165.749 183.065 157.801 183.106 155.101 180.02Z"
        fill="#00B6EF"
      />
      <path
        opacity={0.35}
        d="M155.101 180.02L143.143 156.451H131.704L155.111 180.041L155.101 180.02Z"
        fill="#0D1035"
      />
      <path
        d="M90.1675 46.8044L76.4033 17.5504C75.5935 14.1987 76.03 10.6668 77.6315 7.61304L77.4184 7.99876L1.43122 164.439C0.615431 166.118 0.138313 167.941 0.0271093 169.805C-0.0840949 171.668 0.172793 173.535 0.783105 175.299C1.39342 177.063 2.3452 178.689 3.58412 180.086C4.82303 181.482 6.32481 182.62 8.00371 183.436C9.68262 184.252 11.5058 184.729 13.3691 184.84C15.2323 184.951 17.0993 184.694 18.8633 184.084C20.6273 183.474 22.2539 182.522 23.65 181.283C25.0462 180.044 26.1847 178.542 27.0005 176.864L85.6099 56.1835L90.1675 46.8044Z"
        fill="#00B6EF"
      />
      <path
        opacity={0.35}
        d="M90.1675 46.8043L76.3932 17.53L76.4439 17.7736L85.6099 56.1834L90.1675 46.8043Z"
        fill="#0D1035"
      />
      <path
        d="M165.799 184.872C163.125 184.875 160.504 184.123 158.238 182.702C155.972 181.282 154.153 179.251 152.989 176.843L77.4082 20.3925C75.8197 17.0058 75.6306 13.1295 76.8818 9.60429C78.1331 6.07911 80.7238 3.18943 84.0919 1.56214C87.4601 -0.0651509 91.334 -0.298814 94.8733 0.911843C98.4127 2.1225 101.332 4.67983 102.998 8.02906L178.579 164.439C179.625 166.604 180.104 168.999 179.972 171.4C179.841 173.801 179.102 176.13 177.825 178.167C176.548 180.205 174.775 181.885 172.672 183.05C170.568 184.216 168.204 184.829 165.799 184.832V184.872Z"
        fill="url(#paint0_linear_7503_28037)"
      />
      <path
        d="M76.4439 17.7736C76.4479 17.6992 76.4479 17.6247 76.4439 17.5503V17.7736Z"
        fill="url(#paint1_linear_7503_28037)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_7503_28037"
        x1={59.9391}
        y1={24.3816}
        x2={196.058}
        y2={160.501}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB0D8C" />
        <stop offset={0.17} stopColor="#D72790" />
        <stop offset={0.36} stopColor="#C24699" />
        <stop offset={0.38} stopColor="#BE469A" />
        <stop offset={0.53} stopColor="#A3499B" />
        <stop offset={0.68} stopColor="#90499C" />
        <stop offset={0.83} stopColor="#854B9D" />
        <stop offset={1} stopColor="#814B9D" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7503_28037"
        x1={76.3424}
        y1={17.5706}
        x2={77.1341}
        y2={18.3623}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB0D8C" />
        <stop offset={0.17} stopColor="#D72790" />
        <stop offset={0.36} stopColor="#C24699" />
        <stop offset={0.38} stopColor="#BE469A" />
        <stop offset={0.53} stopColor="#A3499B" />
        <stop offset={0.68} stopColor="#90499C" />
        <stop offset={0.83} stopColor="#854B9D" />
        <stop offset={1} stopColor="#814B9D" />
      </linearGradient>
      <clipPath id="clip0_7503_28037">
        <rect width={180} height={184.872} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Logo = styled(BaseLogo)``;
